module.exports = __webpack_public_path__ + "img/right-border.7eeb676c.png";